import { render, staticRenderFns } from "./StartupCostsBreakdown.vue?vue&type=template&id=cea608ce"
import script from "./StartupCostsBreakdown.vue?vue&type=script&lang=js"
export * from "./StartupCostsBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports